import PageLayout from "@/components/layout/PageLayout";
import PageHeaderTitle from "@/components/layout/PageHeaderText";
import { i18n } from "@lingui/core";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import PumpHeader from "./-components/PumpHeader";
import PumpTables from "./-components/PumpTables";
import Providers from "./-providers";
import PumpPageErrorHandler from "./-components/PumpPageErrorHandler";
import { translateBrand } from "@/lib/i18n";
import { BrandMessageIds } from "@nitro-ape/shared/lib/brand-config";

const schema = z.object({
  error: z.string().optional(),
});

export const Route = createFileRoute("/_main/pump/")({
  validateSearch: (search) => schema.parse(search),
  head: () => ({
    meta: [
      {
        title: translateBrand(BrandMessageIds.metaTitleTrenches),
      },
    ],
  }),
  component: PumpPage,
});

function PumpPage() {
  return (
    <PumpPageErrorHandler>
      <PageLayout>
        <Providers>
          <div className="flex h-full w-full flex-col gap-1.5 overflow-hidden">
            <div className="flex w-full flex-1 flex-col gap-1.5 overflow-hidden">
              <PumpHeader />
              <PumpTables />
            </div>
          </div>
        </Providers>
      </PageLayout>
    </PumpPageErrorHandler>
  );
}
